
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/smart-chains/tutorials/basic-environment-setup-for-linux-vps",
      function () {
        return require("private-next-pages/docs/smart-chains/tutorials/basic-environment-setup-for-linux-vps/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/smart-chains/tutorials/basic-environment-setup-for-linux-vps"])
      });
    }
  